// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file push-notifications.proto (syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { ChatIdentity } from './chat-identity_pb'
import { file_chat_identity } from './chat-identity_pb'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file push-notifications.proto.
 */
export const file_push_notifications: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_chat_identity],
  )

/**
 * @generated from message PushNotificationRegistration
 */
export type PushNotificationRegistration =
  Message<'PushNotificationRegistration'> & {
    /**
     * @generated from field: PushNotificationRegistration.TokenType token_type = 1;
     */
    tokenType: PushNotificationRegistration_TokenType

    /**
     * @generated from field: string device_token = 2;
     */
    deviceToken: string

    /**
     * @generated from field: string installation_id = 3;
     */
    installationId: string

    /**
     * @generated from field: string access_token = 4;
     */
    accessToken: string

    /**
     * @generated from field: bool enabled = 5;
     */
    enabled: boolean

    /**
     * @generated from field: uint64 version = 6;
     */
    version: bigint

    /**
     * @generated from field: repeated bytes allowed_key_list = 7;
     */
    allowedKeyList: Uint8Array[]

    /**
     * @generated from field: repeated bytes blocked_chat_list = 8;
     */
    blockedChatList: Uint8Array[]

    /**
     * @generated from field: bool unregister = 9;
     */
    unregister: boolean

    /**
     * @generated from field: bytes grant = 10;
     */
    grant: Uint8Array

    /**
     * @generated from field: bool allow_from_contacts_only = 11;
     */
    allowFromContactsOnly: boolean

    /**
     * @generated from field: string apn_topic = 12;
     */
    apnTopic: string

    /**
     * @generated from field: bool block_mentions = 13;
     */
    blockMentions: boolean

    /**
     * @generated from field: repeated bytes allowed_mentions_chat_list = 14;
     */
    allowedMentionsChatList: Uint8Array[]

    /**
     * @generated from field: repeated bytes muted_chat_list = 15;
     */
    mutedChatList: Uint8Array[]
  }

/**
 * Describes the message PushNotificationRegistration.
 * Use `create(PushNotificationRegistrationSchema)` to create a new message.
 */
export const PushNotificationRegistrationSchema: GenMessage<PushNotificationRegistration> =
  /*@__PURE__*/
  messageDesc(file_push_notifications, 0)

/**
 * @generated from enum PushNotificationRegistration.TokenType
 */
export enum PushNotificationRegistration_TokenType {
  /**
   * @generated from enum value: UNKNOWN_TOKEN_TYPE = 0;
   */
  UNKNOWN_TOKEN_TYPE = 0,

  /**
   * @generated from enum value: APN_TOKEN = 1;
   */
  APN_TOKEN = 1,

  /**
   * @generated from enum value: FIREBASE_TOKEN = 2;
   */
  FIREBASE_TOKEN = 2,
}

/**
 * Describes the enum PushNotificationRegistration.TokenType.
 */
export const PushNotificationRegistration_TokenTypeSchema: GenEnum<PushNotificationRegistration_TokenType> =
  /*@__PURE__*/
  enumDesc(file_push_notifications, 0, 0)

/**
 * @generated from message PushNotificationRegistrationResponse
 */
export type PushNotificationRegistrationResponse =
  Message<'PushNotificationRegistrationResponse'> & {
    /**
     * @generated from field: bool success = 1;
     */
    success: boolean

    /**
     * @generated from field: PushNotificationRegistrationResponse.ErrorType error = 2;
     */
    error: PushNotificationRegistrationResponse_ErrorType

    /**
     * @generated from field: bytes request_id = 3;
     */
    requestId: Uint8Array
  }

/**
 * Describes the message PushNotificationRegistrationResponse.
 * Use `create(PushNotificationRegistrationResponseSchema)` to create a new message.
 */
export const PushNotificationRegistrationResponseSchema: GenMessage<PushNotificationRegistrationResponse> =
  /*@__PURE__*/
  messageDesc(file_push_notifications, 1)

/**
 * @generated from enum PushNotificationRegistrationResponse.ErrorType
 */
export enum PushNotificationRegistrationResponse_ErrorType {
  /**
   * @generated from enum value: UNKNOWN_ERROR_TYPE = 0;
   */
  UNKNOWN_ERROR_TYPE = 0,

  /**
   * @generated from enum value: MALFORMED_MESSAGE = 1;
   */
  MALFORMED_MESSAGE = 1,

  /**
   * @generated from enum value: VERSION_MISMATCH = 2;
   */
  VERSION_MISMATCH = 2,

  /**
   * @generated from enum value: UNSUPPORTED_TOKEN_TYPE = 3;
   */
  UNSUPPORTED_TOKEN_TYPE = 3,

  /**
   * @generated from enum value: INTERNAL_ERROR = 4;
   */
  INTERNAL_ERROR = 4,
}

/**
 * Describes the enum PushNotificationRegistrationResponse.ErrorType.
 */
export const PushNotificationRegistrationResponse_ErrorTypeSchema: GenEnum<PushNotificationRegistrationResponse_ErrorType> =
  /*@__PURE__*/
  enumDesc(file_push_notifications, 1, 0)

/**
 * @generated from message ContactCodeAdvertisement
 */
export type ContactCodeAdvertisement = Message<'ContactCodeAdvertisement'> & {
  /**
   * @generated from field: repeated PushNotificationQueryInfo push_notification_info = 1;
   */
  pushNotificationInfo: PushNotificationQueryInfo[]

  /**
   * @generated from field: ChatIdentity chat_identity = 2;
   */
  chatIdentity?: ChatIdentity
}

/**
 * Describes the message ContactCodeAdvertisement.
 * Use `create(ContactCodeAdvertisementSchema)` to create a new message.
 */
export const ContactCodeAdvertisementSchema: GenMessage<ContactCodeAdvertisement> =
  /*@__PURE__*/
  messageDesc(file_push_notifications, 2)

/**
 * @generated from message PushNotificationQuery
 */
export type PushNotificationQuery = Message<'PushNotificationQuery'> & {
  /**
   * @generated from field: repeated bytes public_keys = 1;
   */
  publicKeys: Uint8Array[]
}

/**
 * Describes the message PushNotificationQuery.
 * Use `create(PushNotificationQuerySchema)` to create a new message.
 */
export const PushNotificationQuerySchema: GenMessage<PushNotificationQuery> =
  /*@__PURE__*/
  messageDesc(file_push_notifications, 3)

/**
 * @generated from message PushNotificationQueryInfo
 */
export type PushNotificationQueryInfo = Message<'PushNotificationQueryInfo'> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string

  /**
   * @generated from field: string installation_id = 2;
   */
  installationId: string

  /**
   * @generated from field: bytes public_key = 3;
   */
  publicKey: Uint8Array

  /**
   * @generated from field: repeated bytes allowed_key_list = 4;
   */
  allowedKeyList: Uint8Array[]

  /**
   * @generated from field: bytes grant = 5;
   */
  grant: Uint8Array

  /**
   * @generated from field: uint64 version = 6;
   */
  version: bigint

  /**
   * @generated from field: bytes server_public_key = 7;
   */
  serverPublicKey: Uint8Array
}

/**
 * Describes the message PushNotificationQueryInfo.
 * Use `create(PushNotificationQueryInfoSchema)` to create a new message.
 */
export const PushNotificationQueryInfoSchema: GenMessage<PushNotificationQueryInfo> =
  /*@__PURE__*/
  messageDesc(file_push_notifications, 4)

/**
 * @generated from message PushNotificationQueryResponse
 */
export type PushNotificationQueryResponse =
  Message<'PushNotificationQueryResponse'> & {
    /**
     * @generated from field: repeated PushNotificationQueryInfo info = 1;
     */
    info: PushNotificationQueryInfo[]

    /**
     * @generated from field: bytes message_id = 2;
     */
    messageId: Uint8Array

    /**
     * @generated from field: bool success = 3;
     */
    success: boolean
  }

/**
 * Describes the message PushNotificationQueryResponse.
 * Use `create(PushNotificationQueryResponseSchema)` to create a new message.
 */
export const PushNotificationQueryResponseSchema: GenMessage<PushNotificationQueryResponse> =
  /*@__PURE__*/
  messageDesc(file_push_notifications, 5)

/**
 * @generated from message PushNotification
 */
export type PushNotification = Message<'PushNotification'> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string

  /**
   * @generated from field: bytes chat_id = 2;
   */
  chatId: Uint8Array

  /**
   * @generated from field: bytes public_key = 3;
   */
  publicKey: Uint8Array

  /**
   * @generated from field: string installation_id = 4;
   */
  installationId: string

  /**
   * @generated from field: bytes message = 5;
   */
  message: Uint8Array

  /**
   * @generated from field: PushNotification.PushNotificationType type = 6;
   */
  type: PushNotification_PushNotificationType

  /**
   * @generated from field: bytes author = 7;
   */
  author: Uint8Array
}

/**
 * Describes the message PushNotification.
 * Use `create(PushNotificationSchema)` to create a new message.
 */
export const PushNotificationSchema: GenMessage<PushNotification> =
  /*@__PURE__*/
  messageDesc(file_push_notifications, 6)

/**
 * @generated from enum PushNotification.PushNotificationType
 */
export enum PushNotification_PushNotificationType {
  /**
   * @generated from enum value: UNKNOWN_PUSH_NOTIFICATION_TYPE = 0;
   */
  UNKNOWN_PUSH_NOTIFICATION_TYPE = 0,

  /**
   * @generated from enum value: MESSAGE = 1;
   */
  MESSAGE = 1,

  /**
   * @generated from enum value: MENTION = 2;
   */
  MENTION = 2,

  /**
   * @generated from enum value: REQUEST_TO_JOIN_COMMUNITY = 3;
   */
  REQUEST_TO_JOIN_COMMUNITY = 3,
}

/**
 * Describes the enum PushNotification.PushNotificationType.
 */
export const PushNotification_PushNotificationTypeSchema: GenEnum<PushNotification_PushNotificationType> =
  /*@__PURE__*/
  enumDesc(file_push_notifications, 6, 0)

/**
 * @generated from message PushNotificationRequest
 */
export type PushNotificationRequest = Message<'PushNotificationRequest'> & {
  /**
   * @generated from field: repeated PushNotification requests = 1;
   */
  requests: PushNotification[]

  /**
   * @generated from field: bytes message_id = 2;
   */
  messageId: Uint8Array
}

/**
 * Describes the message PushNotificationRequest.
 * Use `create(PushNotificationRequestSchema)` to create a new message.
 */
export const PushNotificationRequestSchema: GenMessage<PushNotificationRequest> =
  /*@__PURE__*/
  messageDesc(file_push_notifications, 7)

/**
 * @generated from message PushNotificationReport
 */
export type PushNotificationReport = Message<'PushNotificationReport'> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean

  /**
   * @generated from field: PushNotificationReport.ErrorType error = 2;
   */
  error: PushNotificationReport_ErrorType

  /**
   * @generated from field: bytes public_key = 3;
   */
  publicKey: Uint8Array

  /**
   * @generated from field: string installation_id = 4;
   */
  installationId: string
}

/**
 * Describes the message PushNotificationReport.
 * Use `create(PushNotificationReportSchema)` to create a new message.
 */
export const PushNotificationReportSchema: GenMessage<PushNotificationReport> =
  /*@__PURE__*/
  messageDesc(file_push_notifications, 8)

/**
 * @generated from enum PushNotificationReport.ErrorType
 */
export enum PushNotificationReport_ErrorType {
  /**
   * @generated from enum value: UNKNOWN_ERROR_TYPE = 0;
   */
  UNKNOWN_ERROR_TYPE = 0,

  /**
   * @generated from enum value: WRONG_TOKEN = 1;
   */
  WRONG_TOKEN = 1,

  /**
   * @generated from enum value: INTERNAL_ERROR = 2;
   */
  INTERNAL_ERROR = 2,

  /**
   * @generated from enum value: NOT_REGISTERED = 3;
   */
  NOT_REGISTERED = 3,
}

/**
 * Describes the enum PushNotificationReport.ErrorType.
 */
export const PushNotificationReport_ErrorTypeSchema: GenEnum<PushNotificationReport_ErrorType> =
  /*@__PURE__*/
  enumDesc(file_push_notifications, 8, 0)

/**
 * @generated from message PushNotificationResponse
 */
export type PushNotificationResponse = Message<'PushNotificationResponse'> & {
  /**
   * @generated from field: bytes message_id = 1;
   */
  messageId: Uint8Array

  /**
   * @generated from field: repeated PushNotificationReport reports = 2;
   */
  reports: PushNotificationReport[]
}

/**
 * Describes the message PushNotificationResponse.
 * Use `create(PushNotificationResponseSchema)` to create a new message.
 */
export const PushNotificationResponseSchema: GenMessage<PushNotificationResponse> =
  /*@__PURE__*/
  messageDesc(file_push_notifications, 9)
